"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Add single quotes around an item
 *
 * @param  str - The word to add quotes to
 * @returns The word with quotes around it
 */
function addQuotes(str) {
    return str.startsWith("'") && str.endsWith("'") ? str : `'${str}'`;
}
exports.default = addQuotes;
//# sourceMappingURL=addQuotes.js.map